import React from "react"
import { Link } from "gatsby"
import { FaLongArrowAltRight } from "react-icons/fa"
import CourthouseIcon from "./icons/CourthouseIcon"
import JusticeIcon from "./icons/JusticeIcon"
import LawyerIcon from "./icons/LawyerIcon"
import JudgeIcon from "./icons/JudgeIcon"
import ProtectIcon from "./icons/ProtectIcon"
import PolicyIcon from "./icons/PolicyIcon"
import FolderIcon from "./icons/FolderIcon"
import OathIcon from "./icons/OathIcon"
import StatementIcon from "./icons/StatementIcon"
import HouseWithScalesIcon from "./icons/HouseWithScalesIcon"
import Law11Icon from "./icons/Law11Icon"
import Service12Icon from "./icons/Service12Icon"
import FingerprintIcon from "./icons/FingerprintIcon"
import ActIcon from "./icons/ActIcon"
import TypewriterIcon from "./icons/TypewriterIcon"
import WritingToolIcon from "./icons/WritingToolIcon"
import ScrollIcon from "./icons/ScrollIcon"

/**
 * Services 2 Component
 * This section is generating the white version of the services section
 *
 * @param {Object} props
 */
const Services = () => {
  return (
    <section className="services">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 text-center">
            <h2 className="services-title">
            SERVICIOS LEGALES PARA GUATEMALTECOS EN SAN FRANCISCO CALIFORNIA,
            AREA DE LA BAHIA Y LA UNION AMERICANA.
            </h2>
            <p className="services-text">
            A todos aquellos guatemaltecos que residen en
            San Francisco California, a lo largo del área
            de la bahía y la unión americana que deseen
            utilizar nuestros servicios la  certeza
            que su asunto legal será resuelto con
            profesionalismo altamente calificado
            y en forma pronta y cumplida.
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-4 col-md-6 service">
            <div>
              <CourthouseIcon className="service-icon" />
            </div>
            <div>
              <h3 className="service-title">Mandatos</h3>
              <p className="service-text">
              La ley de Guatemala clasifica los Mandatos en Generales, Especiales
              y Judiciales, de esa cuenta existen varios tipos de mandatos que
              dependiendo del negocio o acto jurídico que usted necesite...
              </p>
              <Link className="link service-link" to="/servicios/mandatos">
                <span>Leer más...</span>
                <FaLongArrowAltRight className="right" />
              </Link>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 service">
            <div>
              <JusticeIcon className="service-icon" />
            </div>
            <div>
              <h3 className="service-title">Compra / Venta de Propiedades</h3>
              <p className="service-text">
              Estimado guatemalteco te brindamos asesoría legal cuando desees
              vender una propiedad en Guatemala, para realizar dicha venta
              de manera rápida y segura...
              </p>
              <Link className="link service-link" to="/servicios/compra-venta-de-propiedades/">
                <span>Leer más...</span>
                <FaLongArrowAltRight className="right" />
              </Link>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 service">
            <div>
              <LawyerIcon className="service-icon" />
            </div>
            <div>
              <h3 className="service-title">Testamentarios o Intestados</h3>
              <p className="service-text">
              La sucesión por causa de muerte puede darse de dos formas,
              la primera por voluntad de la persona manifestada a través
              de un testamento en cual dispone a que persona se le hereda los bienes...
              </p>
              <Link className="link service-link" to="/servicios/testamentarios-o-intestados/">
                <span>Leer más...</span>
                <FaLongArrowAltRight className="right" />
              </Link>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 service">
            <div>
              <JudgeIcon className="service-icon" />
            </div>
            <div>
              <h3 className="service-title">Divorcios en Guatemala</h3>
              <p className="service-text">
              El fundamento legal lo encontramos en el libro I
              artículo  154 del Código Civil de Guatemala. La ley señala
              dos formas para obtener su divorcio...
              </p>
              <Link className="link service-link" to="/servicios/divorcios">
                <span>Leer más...</span>
                <FaLongArrowAltRight className="right" />
              </Link>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 service">
            <div>
              <ProtectIcon className="service-icon" />
            </div>
            <div>
              <h3 className="service-title">Testamentos</h3>
              <p className="service-text">
            El testamento es un acto puramente personal y de carácter revocable...
              </p>
              <Link className="link service-link" to="/servicios/testamentos">
                <span>Leer más...</span>
                <FaLongArrowAltRight className="right" />
              </Link>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 service">
            <div>
              <PolicyIcon className="service-icon" />
            </div>
            <div>
              <h3 className="service-title">Reconocimiento de Hijos</h3>
              <p className="service-text">
              El licenciado Erick Claveria le puede ayudar a resolver el
              reconocimiento voluntario de su hijo (a) y el Código civil
              de Guatemala establece dos formas...
              </p>
              <Link className="link service-link" to="/servicios/reconocimiento-de-hijos/">
                <span>Leer más...</span>
                <FaLongArrowAltRight className="right" />
              </Link>
            </div>            
          </div>

          <div className="col-lg-4 col-md-6 service">
            <div>
              <FolderIcon className="service-icon" />
            </div>
            <div>
              <h3 className="service-title">Cambio de nombre</h3>
              <p className="service-text">
              El procedimiento para realizar el cambio de nombre está regulado
              en los artículos 438 y 439 del Código Procesal Civil y Mercantil de Guatemala...
              </p>
              <Link className="link service-link" to="/servicios/cambio-de-nombre/">
                <span>Leer más...</span>
                <FaLongArrowAltRight className="right" />
              </Link>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 service">
            <div>
              <OathIcon className="service-icon" />
            </div>
            <div>
              <h3 className="service-title">Rectificación y reposición de partidas</h3>
              <p className="service-text">
              La reposición de una inscripción, será repuesta por la vía Notarial o Judicial,
              debiendo para el efecto, los Registradores Civiles...
              </p>
              <Link className="link service-link" to="/servicios/rectificacion-y-reposicion-de-partidas/">
                <span>Leer más...</span>
                <FaLongArrowAltRight className="right" />
              </Link>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 service">
            <div>
              <StatementIcon className="service-icon" />
            </div>
            <div>
              <h3 className="service-title">Asientos Extemporáneos</h3>
              <p className="service-text">
              Las inscripciones de hechos y actos relativos al estado civil y capacidad civil
              de las personas naturales, que se realicen después de treinta días de acaecidos
              dichos actos o hechos se considerarán extemporáneas...
              </p>
              <Link className="link service-link" to="/servicios/asientos-extemporaneos/">
                <span>Leer más...</span>
                <FaLongArrowAltRight className="right" />
              </Link>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 service">
            <div>
              <HouseWithScalesIcon className="service-icon" />
            </div>
            <div>
              <h3 className="service-title">Matrimonios</h3>
              <p className="service-text">
              El licenciado Erick Claveria puede darle asesoría legal para realizar su matrimonio
              en Estados Unidos de América por ser Fedatario del Estado de Guatemala para
              posteriormente inscribirlo  en el Registro Nacional de las Personas...
              </p>
              <Link className="link service-link" to="/servicios/matrimonios">
                <span>Leer más...</span>
                <FaLongArrowAltRight className="right" />
              </Link>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 service">
            <div>
              <Law11Icon className="service-icon" />
            </div>
            <div>
              <h3 className="service-title">Guarda y Custodia</h3>
              <p className="service-text">
              Los padres podrán convenir a quién de ellos se confían los hijos; pero el juez,
              por causas graves y motivadas, puede resolver en forma distinta...
              </p>
              <Link className="link service-link" to="/servicios/guarda-y-custodia/">
                <span>Leer más...</span>
                <FaLongArrowAltRight className="right" />
              </Link>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 service">
            <div>
              <ProtectIcon className="service-icon" />
            </div>
            <div>
              <h3 className="service-title">Inmovilización de bienes</h3>
              <p className="service-text">
              El licenciado Erick Claveria recomienda a todo guatemalteco que reside
              en los Estados Unidos de América que realice esta medida protección de
              inmovilización de sus bienes inmuebles en Guatemala para tener una mejor
              tranquilidad y resguardo de sus bienes...
              </p>
              <Link className="link service-link" to="/servicios/inmovilizacion-de-bienes/">
                <span>Leer más...</span>
                <FaLongArrowAltRight className="right" />
              </Link>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 service">
            <div>
              <Service12Icon className="service-icon" />
            </div>
            <div>
              <h3 className="service-title">Defensa Técnica</h3>
              <p className="service-text">
              La defensa de la persona y sus derechos son inviolables. Nadie podrá ser condenado,
              ni privado de sus derechos, sin haber sido citado, oído y vencido en proceso legal...
              </p>
              <Link className="link service-link" to="/servicios/defensa-tecnica/">
                <span>Leer más...</span>
                <FaLongArrowAltRight className="right" />
              </Link>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 service">
            <div>
              <LawyerIcon className="service-icon" />
            </div>
            <div>
              <h3 className="service-title">Doble nacionalidad</h3>
              <p className="service-text">
              Toda persona nacida en el extranjero que sea hijo de padre o madre guatemalteco
              tiene el Derecho Constitucional a obtener la nacionalidad guatemalteca...
              </p>
              <Link className="link service-link" to="/servicios/doble-nacionalidad/">
                <span>Leer más...</span>
                <FaLongArrowAltRight className="right" />
              </Link>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 service">
            <div>
              <FingerprintIcon className="service-icon" />
            </div>
            <div>
              <h3 className="service-title">Identificación de persona</h3>
              <p className="service-text">
              Cualquier persona que, constante y públicamente, hubiere usado y fuere conocida con nombre propio distinto del que aparece en su partida de nacimiento...
              </p>
              <Link className="link service-link" to="/servicios/identificacion-de-persona/">
                <span>Leer más...</span>
                <FaLongArrowAltRight className="right" />
              </Link>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 service">
            <div>
              <ActIcon className="service-icon" />
            </div>
            <div>
              <h3 className="service-title">Contrato de arrendamientos</h3>
              <p className="service-text">
              El arrendamiento es el contrato por el cual una de las partes se obliga a dar el uso o goce de una cosa por cierto tiempo...
              </p>
              <Link className="link service-link" to="/servicios/contratos-de-arrendamiento/">
                <span>Leer más...</span>
                <FaLongArrowAltRight className="right" />
              </Link>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 service">
            <div>
              <TypewriterIcon className="service-icon" />
            </div>
            <div>
              <h3 className="service-title">Restituciones de bienes</h3>
              <p className="service-text">
              La demanda de desocupación puede ser entablada por el propietario, por el que ha entregado un inmueble a otro con la obligación de restituírselo...
              </p>
              <Link className="link service-link" to="/servicios/restitucion-de-bienes/">
                <span>Leer más...</span>
                <FaLongArrowAltRight className="right" />
              </Link>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 service">
            <div>
              <WritingToolIcon className="service-icon" />
            </div>
            <div>
              <h3 className="service-title">Titulación supletoria</h3>
              <p className="service-text">
              Tratándose de bienes inmuebles, la posesión por diez años, con las demás condiciones señaladas en el artículo 620 del código civil...
              </p>
              <Link className="link service-link" to="/servicios/titulacion-supletoria/">
                <span>Leer más...</span>
                <FaLongArrowAltRight className="right" />
              </Link>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 service">
            <div>
              <ScrollIcon className="service-icon" />
            </div>
            <div>
              <h3 className="service-title">Donaciones</h3>
              <p className="service-text">
              El fundamento legal lo encontramos en el artículo 1855 del Código Civil de Guatemala.
              La donación entre vivos es un contrato por el cual una persona transfiere a otra
              la propiedad de una cosa, a título gratuito.
              </p>             
            </div>
          </div>

          <div className="col-lg-4 col-md-6 service">
            <div>
              <PolicyIcon className="service-icon" />
            </div>
            <div>
              <h3 className="service-title">Antecedentes Penales y Policiacos</h3>
              <p className="service-text">
              Podemos tramitar por usted la carencia de antecedentes Penales y Policiacos
              en la Republica de Guatemala.
              </p>             
            </div>
          </div>

        </div>
      </div>
    </section>
  )
}

export default Services
